module.exports = __webpack_public_path__ + "images/icons/flags/FR-8b55daa1.svg";